import { TESTIMONIAL_METRIC_TYPE } from '@sleepstation/components'
import adamAvatarUrl from '../images/illustrations/avatars/patient-adam-53404.svg'
import cynthiaAvatarUrl from '../images/illustrations/avatars/patient-cynthia.svg'
import kyleAvatarUrl from '../images/illustrations/avatars/patient-kyle.svg'
import rasminaAvatarUrl from '../images/illustrations/avatars/patient-rasmina.svg'
import sarahAvatarUrl from '../images/illustrations/avatars/patient-sarah.svg'
import tariqAvatarUrl from '../images/illustrations/avatars/patient-tariq.svg'

const PATIENT_SHORT_STORIES = [
  // ---------------------------------------------------------------------------
  // Adam
  // ---------------------------------------------------------------------------
  {
    patient: {
      name: `Adam`,
      avatarUrl: adamAvatarUrl,
      age: 24,
    },
    facts: [
      { value: `Sleeping badly for 8 years` },
      { value: `Finding it difficult to fall asleep` },
    ],
    metrics: {
      type: TESTIMONIAL_METRIC_TYPE.SLEEP_QUALITY,
      data: {
        before: {
          label: `Before Sleepstation`,
          value: 0.62,
        },
        after: {
          label: `After four sessions`,
          value: 0.95,
        },
      },
    },
    quote: `**Absolutely life changing**, my stress levels have dramatically dropped. **My performance at work is better and my mood has improved hugely**. I’m finding it a lot easier to settle down and relax.`,
  },
  // ---------------------------------------------------------------------------
  // Tariq
  // ---------------------------------------------------------------------------
  {
    patient: {
      name: `Tariq`,
      avatarUrl: tariqAvatarUrl,
      age: 64,
    },
    facts: [
      { value: `Not getting enough sleep` },
      { value: `Finding it hard to cope` },
    ],
    metrics: {
      type: TESTIMONIAL_METRIC_TYPE.TOTAL_SLEEP_TIME,
      data: {
        before: {
          label: `Before Sleepstation`,
          value: 256,
        },
        after: {
          label: `After six sessions`,
          value: 414,
        },
      },
    },
    quote: `**A very positive experience**. My sleep has noticeably improved. I feel **more in control of my sleep**. I now have a more **‘get up and go’** attitude towards my daily life. I would recommend Sleepstation.`,
  },
  // ---------------------------------------------------------------------------
  // Sarah
  // ---------------------------------------------------------------------------
  {
    patient: {
      name: `Cynthia`,
      avatarUrl: cynthiaAvatarUrl,
      age: 52,
    },
    facts: [
      { value: `Waking up frequently during the night` },
      { value: `Experiencing racing thoughts` },
    ],
    metrics: {
      type: TESTIMONIAL_METRIC_TYPE.AVERAGE_TIME_TAKEN_TO_FALL_ASLEEP,
      data: {
        before: {
          label: `Before Sleepstation`,
          value: 90,
        },
        after: {
          label: `After four sessions`,
          value: 10,
        },
      },
    },
    quote: `It’s been three months since I finished Sleepstation and **I have been sleeping really well** and mostly getting 7–8 hours a night. If I wake up, I soon drift back to sleep. **It’s amazing** to finally get some decent sleep. **I’m much happier** and don’t worry about sleep anymore. Thank you all.`,
  },
  // ---------------------------------------------------------------------------
  // Sarah
  // ---------------------------------------------------------------------------
  {
    patient: {
      name: `Sarah`,
      avatarUrl: sarahAvatarUrl,
      age: 28,
    },
    facts: [
      { value: `Feeling groggy in the morning` },
      { value: `Very depressed` },
    ],
    metrics: {
      type: TESTIMONIAL_METRIC_TYPE.GOOD_NIGHTS_SLEEP_PER_WEEK,
      data: {
        before: {
          label: `Before Sleepstation`,
          value: 1,
        },
        after: {
          label: `After four sessions`,
          value: 7,
        },
      },
    },
    quote: `Having the **support and encouragement** from the sleep coaches for different techniques to apply really helped. **The support has been great and my sleep has improved greatly**. I no longer feel depressed. **I’ve got my life back**.`,
  },
  // ---------------------------------------------------------------------------
  // Rasmina
  // ---------------------------------------------------------------------------
  {
    patient: {
      name: `Rasmina`,
      avatarUrl: rasminaAvatarUrl,
      age: 49,
    },
    facts: [
      { value: `Sleeping badly for almost a year` },
      { value: `Suffering for anxiety and panic attacks` },
    ],
    metrics: {
      type: TESTIMONIAL_METRIC_TYPE.SLEEP_QUALITY,
      data: {
        before: {
          label: `Before Sleepstation`,
          value: 0.54,
        },
        after: {
          label: `After four sessions`,
          value: 0.89,
        },
      },
    },
    quote: `I think it’s a **fantastic resource** that should be available to all. I’ve found it **extremely helpful** in dealing with my insomnia and feel that **I’ve slept better in the past couple of weeks than I have done in the past year** or so.`,
  },
  // ---------------------------------------------------------------------------
  // Rasmina
  // ---------------------------------------------------------------------------
  {
    patient: {
      name: `Kyle`,
      avatarUrl: kyleAvatarUrl,
      age: 41,
    },
    facts: [
      { value: `Had trouble sleeping for 3–5 years` },
      { value: `Was reliant on sleeping pills` },
    ],
    metrics: {
      type: TESTIMONIAL_METRIC_TYPE.FALLING_ASLEEP,
      data: {
        before: {
          label: `Before Sleepstation`,
          value: 1,
        },
        after: {
          label: `After four sessions`,
          value: 6,
        },
      },
    },
    quote: `**Sleepstation has really helped me**, mainly with falling asleep quickly and waking up less. The coaches are **so supportive**. The assistance to queries and speed of response is **fantastic**.`,
  },
]

export default PATIENT_SHORT_STORIES
